class API {
	static async get(path) {
		return await API.handle(await fetch ('/api/'+path, {
			method: 'GET'
		}));
	}
	
	static async post(path, data) {
		return await API.handle(await fetch ('/api/'+path, {
			method: 'POST',
			headers: {
				'content-type':'application/json'
			},
			body: JSON.stringify(data)
		}));
	}
	
	static async put(path, data) {
		return await API.handle(await fetch ('/api/'+path, {
			method: 'PUT',
			headers: {
				'content-type':'application/json'
			},
			body: JSON.stringify(data)
		}));
	}
	
	static postPut(path, id, data){
		return id ? API.put(path+'/'+id, data): API.post(path, data);
	}
	
	static async delete(path, data) {
		return (typeof data === 'undefined' || data === null) ?
		await API.handle(await fetch ('/api/'+path, {method: 'DELETE'})) :
		await API.handle(await fetch ('/api/'+path, {
			method: 'DELETE',
			headers: {
				'content-type':'application/json'
			},
			body: JSON.stringify(data)
		}));
	}
	
	static async handle(response) {
		if (response.ok) {
			return await response.json();
		}
		else if (response.status == 401) {
			window.location.href = 'sign-in';
			return;
		}
		makeToast('Unknown error!<br>Please refresh the page and try again.');
		Sentry.captureMessage(`API error response \nStatus: ${response.status} \nMessage: ${response.statusText}`);
	}
}